import { render, staticRenderFns } from "./SpeceficVendorsReport.vue?vue&type=template&id=2014f3c5&scoped=true&"
import script from "./SpeceficVendorsReport.vue?vue&type=script&lang=js&"
export * from "./SpeceficVendorsReport.vue?vue&type=script&lang=js&"
import style0 from "./SpeceficVendorsReport.vue?vue&type=style&index=0&id=2014f3c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014f3c5",
  null
  
)

component.options.__file = "SpeceficVendorsReport.vue"
export default component.exports